module.exports = __webpack_public_path__ + "static/img/program_11.7ce746c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/program_11.jpg
// module id = S4wA
// module chunks = 0